<template>
    <div class="main-layout__container">
        <div class="content__header">
            <div class="content-header__title">Мой профиль</div>

            <div class="content-header__background content-header__background--add-edit-page"></div>
        </div>

        <UITabs v-model="activeTab">
            <UITab name="personal" label="Личные данные">
                <PersonalTab />
            </UITab>

            <UITab name="dealers" label="Профили ДЦ">
                <DealersTab />
            </UITab>

            <UITab name="requisites" label="Реквизиты">
                <RequisitesTab />
            </UITab>

            <UITab name="notifications" label="Уведомления">
                <NotificationsTab />
            </UITab>
        </UITabs>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useRoute } from 'vue-router';

    import UITab from '@/components/ui/UITab/UITab.vue';
    import UITabs from '@/components/ui/UITabs/UITabs.vue';

    import DealersTab from '@/views/profile/Profile/components/DealersTab/DealersTab.vue';
    import NotificationsTab from '@/views/profile/Profile/components/NotificationsTab/NotificationsTab.vue';
    import PersonalTab from '@/views/profile/Profile/components/PersonalTab/PersonalTab.vue';
    import RequisitesTab from '@/views/profile/Profile/components/RequisitesTab/RequisitesTab.vue';

    const route = useRoute();

    const activeTab = ref((route.params.tab as string) || 'personal');
</script>

<style scoped lang="scss">
    @use './Profile.scss' as *;
</style>
